export const MINT_CONFIG = {
  base: {
    totalSupply: 121,
    price: "0.0013", // In ETH
    maxPerWallet: 0, // No limit
    enabled: true, // Enabled for Base minting
  },
  pulsechain: {
    totalSupply: 50, // Updated for initial free mint
    price: "0", // Free mint
    maxPerWallet: 0, // No limit
    enabled: true, // Only PLS is enabled
  },
  chia: {
    totalSupply: 9324,
    price: "0.2", // In XCH
    maxPerWallet: 0, // No limit
    enabled: true, // Enabled for Chia minting
  },
} as const;

// Chain display names
export const CHAIN_NAMES = {
  base: "Base",
  pulsechain: "PulseChain",
  chia: "Chia",
} as const;

// Mint is live (no countdown)
export const MINT_START_DATE = "2024-01-01T00:00:00Z";

// Chain availability status - separate from countdown
export const CHAIN_AVAILABILITY = {
  base: true,     // Enabled for Base minting
  pulsechain: true,  // Only chain that's enabled
  chia: true,     // Enabled for Chia minting
} as const;
  